import { RootState } from '../index';
import { StoreStatus } from '../../core/types/common.types';
import { StagedShipment } from '../../core/api/lab.types';

export const stagedShipmentListHasErrorSelector = (state: RootState): boolean =>
  state.stagedShipmentList.errors && state.stagedShipmentList.errors ? true : false;

export const stagedShipmentListIsBusySelector = (state: RootState): boolean =>
  state.stagedShipmentList.status === StoreStatus.BUSY;

export const stagedShipmentListResponseSelector = (state: RootState): StagedShipment | null =>
  state.stagedShipmentList.response || null;
